import React, { FC } from 'react';

import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material';

type DrawProps = {
  children?: React.ReactNode;
  anchor?: MuiDrawerProps['anchor'];
  open?: MuiDrawerProps['open'];
  hideBackdrop?: boolean;
  variant?: MuiDrawerProps['variant'];
  onClose?: MuiDrawerProps['onClose'];

  width?: number;
};

const Drawer: FC<DrawProps> = ({ children, anchor, open, hideBackdrop, variant, width, onClose }) => {
  return (
    <MuiDrawer
      anchor={anchor || 'right'}
      open={open}
      ModalProps={{
        BackdropProps: {
          ...(hideBackdrop ? { invisible: true } : {}),
          'data-testid': 'side-panel-backdrop',
        } as React.HTMLAttributes<HTMLDivElement>,
      }}
      variant={variant}
      PaperProps={{
        sx: {
          width: width || 644,
          // MuiDrawer's slide transition sets the duration and easing inline. Include width in the
          // same transition so dynamic drawer sizes animate without replacing the slide behavior.
          transitionProperty: 'transform, width !important',
          top: (theme) => theme.spacing(1.5),
          right: (theme) => theme.spacing(1.5),
          borderRadius: '12px',
          height: 'calc(100% - 24px)',
          '@media (prefers-reduced-motion: reduce)': {
            transitionProperty: 'none !important',
          },
        },
      }}
      onClose={onClose}
    >
      {children}
    </MuiDrawer>
  );
};

export default Drawer;
